// src/pages/authentication/ForgotPassword.tsx
import React, { useState } from 'react';
import { Container, Typography, TextField, Button, Stack, Alert, Snackbar, Box } from '@mui/material';
import { ForgotUserPassword } from '../../../lib/api/AuthUser';
import { useNavigate } from 'react-router-dom';
import { PAGES_URLS } from '../../../lib/constants/routes';

function ForgotPassword() {
  const [username, setUsername] = useState<string>('');
  const [errMsg, setErrMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const navigate = useNavigate();

  const handleForgotPassword = async (event: React.FormEvent) => {
    event.preventDefault();
    if (username.trim()) {
      try {
        await ForgotUserPassword(username.trim());
        setSuccessMsg(
          'Wenn ein Konto mit diesem Benutzernamen existiert, wurde eine E-Mail zum Zurücksetzen des Passworts gesendet.'
        );
      } catch (error) {
        console.error('Error sending password reset email:', error);
        setErrMsg('Fehler beim Senden der E-Mail zum Zurücksetzen des Passworts.');
      }
    } else {
      setErrMsg('Bitte geben Sie Ihren Benutzernamen ein.');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Passwort vergessen
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Bitte geben Sie Ihren Benutzernamen ein, um Ihr Passwort zurückzusetzen.
      </Typography>
      {errMsg && (
        <Snackbar open={Boolean(errMsg)} autoHideDuration={6000} onClose={() => setErrMsg('')}>
          <Alert severity="error" onClose={() => setErrMsg('')}>
            {errMsg}
          </Alert>
        </Snackbar>
      )}
      {successMsg && (
        <Snackbar open={Boolean(successMsg)} autoHideDuration={6000} onClose={() => setSuccessMsg('')}>
          <Alert severity="success" onClose={() => setSuccessMsg('')}>
            {successMsg}
          </Alert>
        </Snackbar>
      )}
      <form onSubmit={handleForgotPassword}>
        <Stack spacing={2}>
          <TextField
            fullWidth
            label="Benutzername"
            variant="outlined"
            size="medium"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <Button variant="contained" color="primary" size="large" type="submit">
            Passwort zurücksetzen
          </Button>
          <Box>
            <Button color="primary" onClick={() => navigate(PAGES_URLS.Login)}>
              Zurück zum Login
            </Button>
          </Box>
        </Stack>
      </form>
    </Container>
  );
}

export default ForgotPassword;
